import script from "./PartnerTagsList.vue?vue&type=script&setup=true&lang=js"
export * from "./PartnerTagsList.vue?vue&type=script&setup=true&lang=js"

import "./PartnerTagsList.vue?vue&type=style&index=0&id=4154bbea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4154bbea"]])

export default __exports__